export default class Monitor {

    constructor() {
        this.scrollElm = document.querySelector('.js-monitor_scroll');
        this.scrollEffects = document.querySelectorAll('.js-scrolleffect');
        this.bgInnerElm = document.querySelector('.js-monitor-bg-inner');
        this._scrollTimer = null;
    }

    
    setup() {
        if(!this.scrollElm) return;
        this.scrollElm.addEventListener('scroll', this._onScroll.bind(this));
        this._setupAnimationEndListener();
        this._updateInviewElement();
    }

    
    _onScroll() {
        if(this._scrollTimer !== null) clearTimeout(this._scrollTimer);

        // スクロールが停止したことを検知するためのタイマーを設定
        this._scrollTimer = setTimeout(() => {
            this.bgInnerElm.classList.add('-attention');
        }, 150);

        this._updateInviewElement();
    }


    /**
     * CSSアニメーション終了時のイベントリスナーを設定
     */
    _setupAnimationEndListener() {
        this.bgInnerElm.addEventListener('animationend', () => {
            this.bgInnerElm.classList.remove('-attention');
        });
    }


    /**
     * 要素が可視範囲に入っているかどうかを判定する
     * @param {HTMLElement} elm - 判定対象の要素
     * @returns {boolean} - 要素が可視範囲に入っているかどうか
     */
    _isInView(elm) {
        const rect = elm.getBoundingClientRect();
        const scrollTop = this.scrollElm.scrollTop;
        const scrollBottom = scrollTop + this.scrollElm.clientHeight;
        const elementTop = rect.top + scrollTop;
        const elementBottom = rect.bottom + scrollTop;
        return (elementTop < scrollBottom) && (elementBottom > scrollTop);
    }


    /**
     * スクロールエフェクトの対象が画面内に入ってきたらCSSクラスを付加して、
     * 表示アニメーションを実装する
     */
    _updateInviewElement(){

        this.scrollEffects.forEach(elm => {

            if(this._isInView(elm)){
                if(!elm.classList.contains('-inview')) elm.classList.add('-inview');
            }
        });
    }
}
